import styled from 'styled-components'

interface TextProps {
  centered?: any;
  sm?: any;
  xsm?: any;
  intM?: any;
  intL?: any;
}

export const TextDefault = styled.p<TextProps> `
    position: relative;
    font-family: "Book";
    font-size: ${(props: TextProps) => props.sm ? "16px" :
    (props: TextProps) => props.xsm ? "14px" : "17px"};
    color: #003b5c;
    line-height: ${(props: TextProps) => props.intL ? "28px" :
    (props: TextProps) => props.intM ? "25px" : "22px"};
    text-align: ${(props: TextProps) => props.centered ? "center" : "left"};
    max-width: 100%;
    strong {
        font-family: 'Bold';
        font-weight: bold;
    }
    line-height: 150%;
`

export const TextDefaultItalic = styled(TextDefault)`
    font-family: "Medium";
    font-style: italic;
`

export const TextCtaSub = styled(TextDefault)`
    font-family: "Unipol-Medium";
    text-decoration: underline;
    line-height: 150%;
`

export const TextDefaultSmall = styled(TextDefault)`
    font-size: 15px;
    font-family: "Unipol-Book";
    line-height: 23px;
    text-align: center;
    color: #003b5c;

    &.left {
        text-align: left;
    }

    &.LINEAR {
      font-family: Roboto-Regular;
      color: #6F6F6F;
      font-size: 16px;
      line-height: 24px;
    }
`

export const TextLight = styled(TextDefault)`
    font-size: 16px;
    color: #3079c9;
`

export const TextLightB = styled(TextLight)`
    font-weight: bold;
`

export const BigText = styled(TextLight)`
    font-family: "Bold";
    color: #3079c9;
    font-size: 19px;
    line-height: 25px;
    text-align: center;
`

export const WhiteText = styled(TextDefault)`
    color: #fff;
`

export const PageTitleStandard = styled(TextLightB)`
    font-family: "Bold";
    line-height: 29px;
    font-size: 20px;
    text-align: center;
    color: #003b5c;
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
`

export const PageTitle = styled(PageTitleStandard)`
    &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100px;
        height: 2px;
        background-color: #0f3250;
    }
`

export const TextB = styled.p<TextProps> `
    font-family: "Medium";
    text-align: center;
    color: #3079c9;
    line-height: 22px;
    font-size: 17px;
    max-width: 100%;
`

export const LCardLabel = styled.div`
    color: #8A8A8A;
    margin-right: auto;
`

export const LCardValue = styled.div`
  flex-direction: column;
  align-items: flex-start;
`

export const LTitleIconSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: nowrap;
  flex-direction: row;
`;

export const LPageTitle = styled.div`
  font-family: "Linear-Black";
  color: #3C7B35;
  font-size: 20px;
  line-height: 24px;
  margin: 0;
  flex: 1;
  word-break: break-word;
  width: 100%;
  text-transform: uppercase;
`;


export const LPageEnd = styled.div`
  font-family: "Linear-Black";
  color: #499640;
  font-size: 24px;
  line-height: 32px;
  margin: 0;
  flex: 1;
  word-break: break-word;
  width: 100%;
  text-transform: uppercase;
  text-align: center;
`;

export const LEndPageTitle = styled.div`
  font-family: "Linear-Black";
  color: #fff;
  font-size: 24px;
  line-height: 32px;
  word-break: break-word;
  text-transform: uppercase;
  text-align: center;
`;

export const LQuestionText = styled.div`
  font-family: "Linear-Bold";
  color: #6F6F6F;
  font-size: 24px;
  line-height: 32px;
  margin: 0;
  word-break: break-word;
  text-align: center;
`;

export const LEndText = styled.div`
  font-family: "Roboto-Regular";
  color: #fff;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  word-break: break-word;
  text-align: center;
`;


export const LSmallPageTitle = styled(LPageTitle)`
  font-size: 16px;
  line-height: 20px;
`;

export const LSimpleText = styled.div<{ $inverted?: boolean }>`
  font-family: "Roboto-Regular";
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: ${({ $inverted }) => $inverted ? 'white' : '#575757'};

  &.is-in-multi-card.max-limit-warning {
    display: none;
  }

  ul {
    list-style-position: outside;
  }

  strong {
    color: ${({ $inverted }) => $inverted ? 'white' : '#6F6F6F'};
    font-family: "Roboto-Bold";
    font-weight: 700;
  }

  &.left {
    color: ${({ $inverted }) => $inverted ? 'white' : '#6F6F6F'};
    text-align: left;
    //font-size: 16px;
    width: 100%;
  }
`;

export const LErrorTxt = styled(LSimpleText)`
  color: #FF3300;
`

export const LSimpleTextSmall = styled(LSimpleText)`
  font-size: 14px;
  line-height: 20px;
`

export const LCardTitle = styled.div`
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 10px;

  strong {
        color: #3D3D3D;
        font-family: "Roboto-Bold";
    }
`

export const LCardRow = styled.div`
    width: 100%;
    display: flex;
    padding: 4px 0;
;
`

export const LPostTextError = styled.div`
  font-family: "Roboto-Regular";
  color: red;
  font-size: 14px;
  line-height: 16px;
  margin: 0;
  flex: 1;
  word-break: break-word;
  width: 100%;
`;
